/* FloatingContainer.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["paddingAdjustments", "rainbowBorder", "rainbowBorderAnimation", "disablePadding", "children", "enableMaxHeight", "className", "style"];
import "./FloatingContainer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */

import { forwardRef } from 'react';
var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
var PRISM_BORDER_STEP_1 = '#0065FF';
var PRISM_BORDER_STEP_2 = '#0469FF';
var PRISM_BORDER_STEP_3 = '#BF63F3';
var PRISM_BORDER_STEP_4 = '#FFA900';
var defaultPadding = {
  top: 12,
  bottom: 12,
  left: 12,
  right: 12
};

// ED-20633, DSP-14045: Avoid space tokens for now as space tokens are currently using rem units
// and Safari has a bug where rem is incorrectly calculated when there are
// animations involved
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var prismBorderStyles = null;
var staticStyles = {
  default: "_16r2w4bv _1s6kw4bv",
  firefox: "_16r21l3w _1s6k1l3w _19h915ob _1ank15ob"
};
var fireFoxBgPosition = null;
var rotationAnimation = null;
var animationStyles = {
  default: "_46tszp6o _16qqzp6o",
  firefox: "_46tsgk6c _16qqgk6c"
};

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var constantStyles = null;
var maxHeightCSS = null;
export var FloatingContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _paddingAdjustments$t, _paddingAdjustments$r, _paddingAdjustments$b, _paddingAdjustments$l;
  var paddingAdjustments = _ref.paddingAdjustments,
    _ref$rainbowBorder = _ref.rainbowBorder,
    rainbowBorder = _ref$rainbowBorder === void 0 ? true : _ref$rainbowBorder,
    rainbowBorderAnimation = _ref.rainbowBorderAnimation,
    disablePadding = _ref.disablePadding,
    children = _ref.children,
    enableMaxHeight = _ref.enableMaxHeight,
    className = _ref.className,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className: ax([rainbowBorder && "_2rkopd34 _kqswh2mm _16qsglyw _14mjw3o8 _rfx3w3o8 _aetrb3bt _1kt9b3bt _18postnw _1cs8stnw _1bqq1mrw _1g0v1mrw _z0ai1b4h _1mp41b4h _1qdg1b4h _kfgt1b4h _15l21n1a _1auk1n1a _19do1n1a _qnec1n1a _clh3161g _7dwz161g _32rxt94y _1x88t94y _15l21pry _1peq105o _ta6yglyw", staticStyles[isFirefox ? 'firefox' : 'default'], "_2rkopd34 _16qs1cd0 _4t3i1osq _1bsb1osq _vchhusvi _bfhk1bhr _10kl1kw7 _ktt71kw7", rainbowBorderAnimation && animationStyles[isFirefox ? 'firefox' : 'default'], enableMaxHeight && "_c71ldgin", className])
  }, rest, {
    style: _objectSpread(_objectSpread(_objectSpread({}, style), disablePadding ? null : paddingAdjustments ? {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      paddingTop: "".concat(defaultPadding.top + ((_paddingAdjustments$t = paddingAdjustments.top) !== null && _paddingAdjustments$t !== void 0 ? _paddingAdjustments$t : 0), "px"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      paddingRight: "".concat(defaultPadding.right + ((_paddingAdjustments$r = paddingAdjustments.right) !== null && _paddingAdjustments$r !== void 0 ? _paddingAdjustments$r : 0), "px"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      paddingBottom: "".concat(defaultPadding.bottom + ((_paddingAdjustments$b = paddingAdjustments.bottom) !== null && _paddingAdjustments$b !== void 0 ? _paddingAdjustments$b : 0), "px"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      paddingLeft: "".concat(defaultPadding.left + ((_paddingAdjustments$l = paddingAdjustments.left) !== null && _paddingAdjustments$l !== void 0 ? _paddingAdjustments$l : 0), "px")
    } : {
      padding: "".concat(defaultPadding.top, "px ").concat(defaultPadding.left, "px")
    }), {}, {
      "--_amv3i7": ix("calc(".concat("var(--ds-border-radius-200, 8px)", " + 1px)"))
    })
  }), children);
});